import React from "react";
import "./WhyChooseUs.css";

const WhyChooseUs = () => {
  return (
    <div className="why_choose_us_parent_div">
      <h2>Why Choose Us?</h2>
      <p>
        ✅ Experienced team with expertise in construction and material supply.
      </p>
      <p>✅ High-quality materials and industry-best practices.</p>
      <p>✅ Commitment to timely delivery and cost-effectiveness.</p>
      <p>✅ Strong client relationships and transparent business dealings.</p>
    </div>
  );
};

export default WhyChooseUs;
